import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import SrCard, { SR_CARD_FONT_SIZE_SMALL } from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';
import SrLabel from 'client/components/SrLabel/SrLabel';
import SrStripeAccountInfo from 'client/components/SrStripeAccountInfo';

const UPPartnerBankAccountConnected = ({ utilityPartnerSlug, stripeAccount }) => {
  const history = useHistory();

  const connectBankAccountUrl = `/utility-profit/${utilityPartnerSlug}/connect-bank`;

  const onClickChangeBankAccount = () => {
    history.push(connectBankAccountUrl);
  };

  return (
    <>
      <SrCard headerSizeType={SR_CARD_FONT_SIZE_SMALL} header="Connected Bank">
        <SrBox height="21px" />
        <SrStripeAccountInfo stripeAccount={stripeAccount} />
        <SrBox maxWidth="400px">
          <SrLabel
            alignCenter
            justifyCenter
            label="Change Bank Account"
            color="grey"
            borderColor="#7B8488"
            opacity="1"
            onClick={onClickChangeBankAccount}
          />
        </SrBox>
      </SrCard>
    </>
  );
};

UPPartnerBankAccountConnected.propTypes = {
  utilityPartnerSlug: PropTypes.string.isRequired,
  stripeAccount: PropTypes.object.isRequired,
};

UPPartnerBankAccountConnected.displayName = 'UPPartnerBankAccountConnected';

export default UPPartnerBankAccountConnected;
